/**
 * This function can replace sourceString from start to end with replacement
 * For example: replaceAt("sourceString", 0, 1, "newS") return "newSourceString"
 */
export const replaceAt = (
  sourceString: string,
  _start: number,
  _end: number,
  replacement: string
) => {
  let start: number;
  let end: number;
  if (_start < _end) {
    start = _start;
    end = _end;
  } else {
    start = _end;
    end = _start;
  }
  return sourceString.substr(0, start) + replacement + sourceString.substr(end);
};
